"use client";
import React, { useState, useEffect } from 'react';
import GlossaryShare from './GlossaryShare';

const sanitizeHeadingText = (value = '') => {
  const raw = String(value);
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = raw;
    return textarea.value.replace(/ /g, ' ').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  return raw
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export default function GlossaryDetailSidebar({ h2Tags = [] }) {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    if (h2Tags.length > 0) setActiveSection(h2Tags[0].id);
  }, [h2Tags]);

  // Scroll-spy: highlight the section currently in view.
  useEffect(() => {
    if (h2Tags.length === 0) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150;
      let currentSection = '';
      for (let i = h2Tags.length - 1; i >= 0; i--) {
        const element = document.getElementById(h2Tags[i].id);
        if (element && scrollPosition >= element.offsetTop) {
          currentSection = h2Tags[i].id;
          break;
        }
      }
      if (!currentSection && h2Tags.length > 0) currentSection = h2Tags[0].id;
      if (currentSection) setActiveSection(currentSection);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [h2Tags]);

  return (
    <div className="col-lg-4">
      <div className="article-sidebar">
        {/* Table of Contents */}
        <div className="toc-section">
          <h3 className="toc-title">Table of Contents</h3>
          <ul className="toc-list">
            {h2Tags.length > 0 ? (
              h2Tags.map((h2, index) => (
                <li key={index} className={activeSection === h2.id ? 'active' : ''}>
                  <a
                    href={`#${h2.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveSection(h2.id);
                      const element = document.getElementById(h2.id);
                      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                  >
                    {sanitizeHeadingText(h2.text)}
                  </a>
                </li>
              ))
            ) : (
              <li>No headings available</li>
            )}
          </ul>
        </div>

        {/* Share Section */}
        <div className="share-section mt-4">
          <h4 className="share-title">Share</h4>
          <GlossaryShare />
        </div>
      </div>
    </div>
  );
}
